import type { IconName } from "@sylviq/ui-react-web/extensions/icons";
import type { CrateSummary } from "@/lib/api";

// The crate catalog (`GET /crates`) has no icon field of its own — it's
// a backend concept with no notion of frontend iconography. This is a
// best-effort keyword mapping onto `packages/shared/src/icon-names.ts`'s
// fixed set, not a registry a crate opts into; a new crate just falls back
// to "blocks" until someone adds a keyword here.
export function iconForCrate(crate: CrateSummary): IconName {
  const haystack =
    `${crate.key} ${crate.branch_key} ${crate.display_name}`.toLowerCase();
  const rules: Array<[RegExp, IconName]> = [
    [/account|invoic|tax|receipt/, "receipt"],
    [/budget/, "bar-chart"],
    [/loan|expense/, "credit-card"],
    [/asset|tenan|legal|facilit|building/, "building"],
    [/procure|purchas|inventory|shopping/, "shopping-cart"],
    [/employee|hr\b|payroll|people/, "users"],
    [/sales/, "bar-chart"],
    [/crm|contact/, "contact"],
    [/integrat/, "cloud"],
    [/report/, "file-spreadsheet"],
    [/settings|admin|platform/, "settings"],
  ];
  for (const [pattern, icon] of rules) {
    if (pattern.test(haystack)) return icon;
  }
  return "blocks";
}
